import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			id: "check",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M13.3333 4L6 11.3333L2.66667 8",
				stroke: "url(#paint0_linear_0_9)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_0_9",
			x1: 18.5002,
			y1: -1,
			x2: 3.00016,
			y2: 11,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFF58C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F55200"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
